import React, { Fragment } from 'react';
import { Intro, Button } from 'cvs-core';
// import certFile from '../../assets/certificate/CVS-CATCH-BVF-SPM-Certificate.pdf';
import introImg from '../../assets/images/end-screen@2x.jpg';

// We do use noopener in the link below, but jsx-no-target-blank also demands noreferrer for older browsers which we haven't set
/* eslint-disable react/jsx-no-target-blank */
// const data = {
//   title: 'Review Answer Sheet',
//   content: <ReviewSheet />
// };
// {
//   title: 'Explore Additional Modules',
//   content: (
//     <Fragment>
//       <p>
//         <strong>Pathway to Financial Success</strong>
//         <br />
//         Empower high school students to take control of their financial futures.
//         Educators can help students and their families explore comprehensive
//         financial literacy resources to gain the tools and skills they need to
//         make sound financial decisions and achieve their personal goals.
//         <br />
//         <a
//           href="https://www.pathwayinschools.com/"
//           rel="noopener"
//           target="_blank"
//         >
//           www.pathwayinschools.com
//         </a>
//       </p>
//     </Fragment>
//   )
// }

/* eslint-enable react/jsx-no-target-blank */

export default {
  title: 'Complete',
  path: '/complete',
  content: (
    <Fragment>
      <Intro
        title="Congratulations"
        lead="You have debunked some of the common misperceptions of vaping and e-cigarette use. Keep making healthy, smart decisions and help build a generation that will #BeVapeFree."
        // img={introImg}
      />
  
      <img
        className="intro__img--complete"
        src={introImg}
        alt='certificate'
        width="568"
        height="235"
      />
      <div className="cvs-completion">
        {/*<Scoreboard />*/}

        <Button
          classes={
            {
              'cert-download': true,
              
            }
          }
          children="Download Certificate"
          file={process.env.PUBLIC_URL + '/CVS-CATCH-BVF-SPM-Certificate.pdf'}
          // file={certFile}
        />
      </div>

      {/*<Accordion data={data} />*/}
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/certificate/Complete.js